module.exports = __webpack_public_path__ + "static/media/apex_c.52226e50.png";